const initalState = {
    viewInspectionForms: {},
    getInspectionForms: {}
  };


  const InspectionReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
      case "INSPECTION_FORM":
        return {
          ...state,
          viewInspectionForms: payload,
        };
        case "INSPECTION_FORM_DATA":
          return {
            ...state,
            getInspectionForm: payload,
          };
      default:
        return {
          ...state,
        };
    }
  };
  
  export default InspectionReducer;
  